<template>
  <OrderDetails />
</template>
<script lang="js">
import OrderDetails from "@/components/OrderDetails.vue";
export default {
  name: 'OrderDetailsTwo',
  components: { OrderDetails }
}
</script>